module.exports = __webpack_public_path__ + "img/result_wine_b.cf59b9d5.png";